import styles from "./styles.module.css";
import cx from "classnames";

export enum BUTTONTYPE {
  BORDERED = "borderd",
  BG_WHITE = "white",
  WITHOUT_BORDER = "borderNone",
  WITHOUT_SIDEBAR = "sidebar",
  BG_WARNING = "warning",
  BG_GRAY = "gray",
}

type Props = {
  text?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  type?: "submit" | "reset" | "button";
  btnType?: BUTTONTYPE;
  classname?: string;
  icon?: string;
};

export const Button: React.FC<Props> = ({
  text,
  onClick,
  disabled,
  type = "button",
  btnType,
  classname,
  icon,
}) => (
  <button
    type={type}
    disabled={disabled}
    onClick={onClick}
    className={cx(styles.btn, classname, {
      [styles.bordered]: btnType === BUTTONTYPE.BORDERED,
      [styles.white]: btnType === BUTTONTYPE.BG_WHITE,
      [styles.gray]: btnType === BUTTONTYPE.BG_GRAY,
      [styles.borderNone]: btnType === BUTTONTYPE.WITHOUT_BORDER,
      [styles.sidebar]: btnType === BUTTONTYPE.WITHOUT_SIDEBAR,
      [styles.warning]: btnType === BUTTONTYPE.BG_WARNING,
      [styles.disabled]: disabled,
    })}
  >
    {text}
    {icon && <img src={icon} alt="" />}
  </button>
);
